import { createContext, useContext } from "react";

const noop = () => {};

export const ModalContext = createContext({
  openContact: noop,
  openSchedule: noop,
  openPresupuesto: noop,
});

export const useModals = () => useContext(ModalContext);
